<ng-template #matPrefix>
  <span
    *ngIf="to.addonLeft"
    [ngStyle]="{cursor: to.addonLeft.onClick ? 'pointer' : 'inherit'}"
    (click)="addonLeftClick($event)">
    <mat-icon *ngIf="to.addonLeft.icon" color="to.addonLeft.color">{{ to.addonLeft.icon }}</mat-icon>&nbsp;
    <span *ngIf="to.addonLeft.text" color="to.addonLeft.color">{{ to.addonLeft.text }}</span>
  </span>
</ng-template>

<ng-container #fieldComponent></ng-container>

<ng-template #matSuffix>
  <span *ngIf="to.addonRight" [ngStyle]="{cursor: to.addonRight.onClick ? 'pointer' : 'inherit'}"
  (click)="addonRightClick($event)">
    <mat-icon *ngIf="to.addonRight.icon" color="to.addonLeft.color">{{ to.addonRight.icon }}</mat-icon>
    &nbsp;<span *ngIf="to.addonRight.text" color="to.addonLeft.color">{{ to.addonRight.text }}</span>
  </span>
</ng-template>
